export class PitrBackupSchedules {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "intervalConfig",
            "baseName": "intervalConfig",
            "type": "PitrIntervalConfig",
            "format": ""
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PitrBackupSchedules.attributeTypeMap;
    }
    constructor() {
    }
}
